/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
// Pass in an event object,
// and returns the coordinates of the event relative to the target element.
import { getHitElement } from "utils/DomUtils";
import PageCanvasCss from "components/document/page/PageCanvas.css";
import { getCoordinatesRelativeToTarget } from "dc-preview-utils/src/Utils/EventHandlingUtils";

export const getCoordinatesRelativeToTargetElem = evt => {
  const targetElem = evt.target;
  const elementBoundingRects = targetElem.getBoundingClientRect();

  return {
    x: evt.pageX - elementBoundingRects.left - document.documentElement.scrollLeft,
    y: evt.pageY - elementBoundingRects.top - document.documentElement.scrollTop
  };
};

/* istanbul ignore next */
function getCoordinatesRelativeToPage(evt) {
  let targetPage = evt.target;
  // move up to parents till we find page canvas parent.
  while (targetPage && !targetPage.classList.contains(PageCanvasCss.parent)) {
    targetPage = targetPage.parentElement;
  }
  if (!targetPage) targetPage = getHitElement(PageCanvasCss.parent, evt.pageX, evt.pageY);
  return getCoordinatesRelativeToTarget(evt, targetPage);
}

export { getCoordinatesRelativeToPage };

// In windows touch context menu event comes on long press also
export const isContextMenuTriggeredFromTouch = event =>
  (event.pointerType && event.pointerType === "touch") ||
  (event.mozInputSource && event.mozInputSource === 5) ||
  event.which === 0;

export const persistEvent = event => event && event.persist();
